export const OPS_EVENTS = {
    SERVERS_JOIN: 'ops:servers:join',
    SERVERS_LEAVE: 'ops:servers:leave',
    SERVERS: 'ops:servers',
    SERVERS_STATUS: 'ops:servers:status',
    ACTIONS: 'ops:actions',
    RUNS: 'ops:runs',
    ALERTS: 'ops:alerts',
    DEPLOYS: 'ops:deploys',
    ACTIVITY: 'ops:activity',
    LOGS_JOIN: 'ops:logs:join',
    LOGS_LEAVE: 'ops:logs:leave',
    LOGS: 'ops:logs',
    LOGS_STATUS: 'ops:logs:status',
} as const;

export default OPS_EVENTS;
